import React, {useState} from "react";
import {ActivityIndicator} from "react-native";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import API from "../../helpers/Axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {store} from "../../store/configureStore";
import TailwindFloatingInput from "../../components/TailwindFloatingInput";

const SigninScreen = ({navigation}) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showPassword, setShowPassword] = useState(false);

	const [email, setEmail] = useState({
		value: '',
		error: false,
		errorString: null
	});

	const [password, setPassword] = useState({
		value: '',
		error: false,
		errorString: null
	});

	const onSubmit = () => {
		if (isSubmitting) return;
		setIsSubmitting(true);

		const data = {
			email: email.value,
			password: password.value,
		};

		API.post('admin/login-by-email', data)
			.then(res => {
				AsyncStorage.setItem('access_token', res.data.access_token);
				store.dispatch({type: 'TOGGLE_AUTH', user: res.data.user});
				store.dispatch({type: 'UPDATE_ACCESS_TOKEN', accessToken: res.data.access_token});
				navigation.navigate('DashboardStack');
			}).catch (error => {
				setIsSubmitting(false);
				setEmail({
					value: email.value,
					error: error.response.data.errors['email'] !== undefined,
					errorString: error.response.data.errors['email'] !== undefined ? error.response.data.errors['email'][0] : 'Error'
				});
				setPassword({
					value: password.value,
					error: error.response.data.errors['password'] !== undefined,
					errorString: error.response.data.errors['password'] !== undefined ? error.response.data.errors['password'][0] : 'Error'
				});
				if (error.response.data.errors['email'] === undefined && error.response.data.errors['password'] === undefined) {
					setEmail({
						value: email.value,
						error: true,
						errorString: 'These credentials do not match our records.'
					});
					setPassword({
						value: password.value,
						error: true,
						errorString: ''
					});
				}
			});
	};

	return (
		<div
			className="relative flex min-h-screen w-full items-center justify-center bg-[#1D1F1E] bg-cover bg-center"
			style={{backgroundImage: "url('/assets/splash/1.jpeg')"}}
		>
			<div className="absolute inset-0 bg-[rgba(29,31,30,0.4)]" />
			<div className="relative min-w-[450px] rounded-lg bg-white p-12">
				<h1 className="mb-6 text-[34px] font-semibold text-[#3DBA71]">Welcome back!</h1>
				<p className="mb-6 text-[20px] text-[#6D6E6F]">Log in to your Stugo admin panel.</p>
				<div className="mt-4">
					<TailwindFloatingInput
						label="Email"
						type="email"
						value={email.value}
						error={email.error}
						errorText={email.errorString || ""}
						onChange={(val) => {
							setEmail({
								value: val,
								error: false,
								errorString: email.errorString
							});
						}}
						onEnter={onSubmit}
					/>
					<div className="mt-10">
						<TailwindFloatingInput
							label="Password"
							type={showPassword ? "text" : "password"}
							value={password.value}
							error={password.error}
							errorText={password.errorString || ""}
							onChange={(val) => {
								setPassword({
									value: val,
									error: false,
									errorString: password.errorString
								});
							}}
							onEnter={onSubmit}
								rightSlot={(
									<button
										type="button"
										onClick={() => setShowPassword((prev) => !prev)}
										aria-label={showPassword ? "Hide password" : "Show password"}
										aria-pressed={showPassword}
										className="flex h-6 w-6 items-center justify-center text-[#B7B7B7] transition-colors hover:text-[#3DBA71]"
									>
										{showPassword ? (
											<svg width="20" height="14" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 11C3.66667 4.33333 8.33333 1 15 1C21.6667 1 26.3333 4.33333 29 11C26.3333 17.6667 21.6667 21 15 21C8.33333 21 3.66667 17.6667 1 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
												<circle cx="15" cy="11" r="4" stroke="currentColor" strokeWidth="2"/>
											</svg>
										) : (
											<svg width="20" height="14" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 11C3.66667 4.33333 8.33333 1 15 1C21.6667 1 26.3333 4.33333 29 11C26.3333 17.6667 21.6667 21 15 21C8.33333 21 3.66667 17.6667 1 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
												<circle cx="15" cy="11" r="4" stroke="currentColor" strokeWidth="2"/>
												<path d="M4 19L26 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
											</svg>
										)}
									</button>
								)}
							/>
						</div>
				</div>
				<p className="mt-6 text-base">
					Forgot your password?{' '}
					<button
						type="button"
						onClick={() => navigation.navigate('ForgotPasswordScreen')}
						className="font-semibold text-[#3DBA71]"
					>
						Recover password
					</button>
				</p>
				<button
					type="button"
					onClick={onSubmit}
					disabled={isSubmitting}
					className="mt-4 flex h-12 w-full items-center justify-center rounded bg-[#3DBA71] text-center text-base font-semibold text-white disabled:opacity-80"
				>
					{isSubmitting ? <ActivityIndicator color={'white'} /> : 'Login'}
				</button>
			</div>
		</div>
	);

}

SigninScreen.propTypes = {
	navigation: PropTypes.object,
};

export default connect(({auth}) => ({auth}))(SigninScreen);
